export const Logo = ({ className = "" }) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Samasta Studio logo"
  >
    <path
      d="M8 6H28V14H14V22H28V30H8"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path d="M14 10V26" stroke="#8C6D53" strokeWidth="1.5" strokeDasharray="2 2" />
  </svg>
);
